// extracted by mini-css-extract-plugin
export default {"container":"style_container__75m41","content":"style_content__ZMCPM"};